import { Button, Stack } from '@chakra-ui/react';
import React from 'react';

import {
  AccountButtonIcon,
  ClaimsButtonIcon,
  SearchButtonIcon,
  SupportButtonIcon,
} from '../../Icons';
import Link from '../../Link';
import { Text } from '../../Text';

interface ActionSectionProps {}

interface ActionButtonProps {
  icon: React.ReactElement;
  href: string;
  label: string;
}

const ButtonStyles = {
  flexDirection: 'row',
  justifyContent: { base: 'start', lg: 'center' },
  marginTop: { base: '16px', laptop: '0' },
  padding: { base: '0 24px 0 20px', laptop: '0 12px' },
  height: '48px',
  fontSize: { base: '14px', laptop: '13px' },
  lineHeight: { base: '19px', laptop: '18px' },
  fontWeight: { base: '700', laptop: '400' },
  color: { base: 'wl-darkBlue', laptop: 'white' },
  textAlign: 'left',
  textDecoration: 'none',
  _hover: {
    color: { base: 'wl-darkBlue.rgb', laptop: 'white' },
    textDecoration: 'none',
    background: { base: 'wl-lightBlue.rgba10', laptop: 'wl-darkBlue.rgba40' },
  },
  _active: {
    color: { base: 'wl-darkBlue.rgb', laptop: 'white' },
    textDecoration: 'none',
    background: { base: 'wl-lightBlue.rgba10', laptop: 'wl-darkBlue.rgba70' },
  },
};

const TextStyles = {
  whiteSpace: 'nowrap',
};

const ActionButton: React.FC<ActionButtonProps> = ({ icon, href, label }) => {
  return (
    <Button
      as={Link}
      variant="ghost"
      aria-label={label}
      to={href}
      leftIcon={icon}
      iconSpacing={{ lg: 0 }}
      sx={ButtonStyles}
    >
      <Text sx={TextStyles}>{label}</Text>
    </Button>
  );
};

const ActionSection: React.FC<ActionSectionProps> = () => {
  return (
    <Stack spacing="0" direction={{ base: 'column', laptop: 'row' }}>
      <ActionButton
        icon={
          <SearchButtonIcon
            marginRight={{ base: '8px', laptop: '0' }}
            fill={{ base: 'blue.700', laptop: 'white' }}
            boxSize="24px"
          />
        }
        label="Search"
        href="/search/"
      />
      <ActionButton
        icon={
          <SupportButtonIcon
            marginRight={{ base: '8px', laptop: '4px' }}
            fill={{ base: 'blue.700', laptop: 'white' }}
            boxSize="24px"
          />
        }
        label="Support"
        href="/contact/"
      />
      <ActionButton
        icon={
          <ClaimsButtonIcon
            marginRight={{ base: '8px', laptop: '4px' }}
            fill={{ base: 'blue.700', laptop: 'white' }}
            boxSize="24px"
          />
        }
        label="Claims"
        href="/claims/"
      />
      <ActionButton
        icon={
          <AccountButtonIcon
            marginRight={{ base: '8px', laptop: '4px' }}
            fill={{ base: 'blue.700', laptop: 'white' }}
            boxSize="24px"
          />
        }
        label="Sign In"
        href="https://member.mywoodmen.org/Member/?_ga=2.203913171.213816262.1643646216-102380624.1635882099"
      />
    </Stack>
  );
};

export default ActionSection;
